//@Version 1.1.0
import {DOCUMENT} from "@angular/common";
import {inject, Inject, Injectable, signal, WritableSignal} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { TRANSLATE_PATH as TRANSLATE_PATH_SHARED } from "../../shared.model";

declare let frameId: string;

@Injectable({
   providedIn: "root"
})
export class ResponsiveService {

   private sTranslate: TranslateService = inject(TranslateService);
   private window!: Window;
   public isBig: WritableSignal<boolean> = signal(true);

   constructor (@Inject(DOCUMENT) private document: Document) {
      this.sTranslate.get(TRANSLATE_PATH_SHARED.IFRAME_SIZE).subscribe(item => this.isBig.set(Boolean(item)))
      this.window = <Window>this.document.defaultView;
   }
    
   get isFrameId (): boolean {
      return !frameId || frameId == '' ? false : true;
   }

   private sendPostMessage () {
      if (frameId == "") return;

      const mainElement = this.document.getElementById("main");
      if (!mainElement) return;

      const heightPage = mainElement.offsetHeight < mainElement.scrollHeight ? mainElement.scrollHeight : mainElement.offsetHeight;
      
      const value = `${frameId}-${heightPage}`;
      this.window.parent.postMessage(value, "*");
   }

   private onInitEventListener () {
   
      this.document.querySelectorAll("button:not(EventManager)").forEach((button) => {
         button.addEventListener("click", () => this.sendPostMessage(), false);
         button.classList.add("EventManager");
      });
      
      this.document.querySelectorAll("mat-select:not(EventManager)").forEach((itemSelect) => {
         const item_ = itemSelect as HTMLSelectElement;
         item_.onclick = () => {
            item_.classList.add("EventManager");
            const lengthOptions = item_.options.length;
            for (let i = 0 ; i < lengthOptions; i++) {
               item_.options[i].onclick = () => this.sendPostMessage();
            }
         };
      });
      
      this.document.querySelectorAll("div.mat-tab-label:not(EventManager)").forEach((item) => {
         const item_ = item as HTMLElement;
         item_.classList.add("EventManager");
         item_.onclick = () => this.sendPostMessage();
      });
            
         
      this.document.querySelectorAll("img:not(EventManager)").forEach((image) => {
         const image_ = image as HTMLElement;
         image_.classList.add("EventManager");
         image_.onload = () => this.sendPostMessage();
      });
      
   }

   private checkChange () {
      if (frameId == "") return;
      const checkLoadHtml = this.document.getElementById("checkLoad") as HTMLInputElement;
      if (!checkLoadHtml) return;
      const defaultHtml = this.document.getElementById("default") as HTMLInputElement;
      if (!defaultHtml) return;

      defaultHtml.value = checkLoadHtml.value;
   }

   public start () {
      this.window.addEventListener("resize", this.sendPostMessage, false);
      this.window.addEventListener("popstate", this.sendPostMessage, false);
      this.window.addEventListener("load", this.sendPostMessage, false);
      this.window.setInterval(this.sendPostMessage, 1000);
      this.window.addEventListener("click", this.sendPostMessage);
      this.window.setInterval(this.checkChange, 1000);

   }
}
